import { useLocation } from 'react-router-dom';
import { DexBreadcrumb, type DexBreadcrumbCrumb } from '@dexmate/dexui';

const SEGMENT_LABELS: Record<string, string> = {
  data: 'Data',
  trajectories: 'Trajectories',
  admin: 'Admin',
  throughput: 'Throughput',
  operators: 'Operators',
  integrity: 'Integrity',
  'cold-storage': 'Cold storage',
  search: 'ML Search',
  annotation: 'Annotation',
  tokens: 'Tokens',
};

function humanise(seg: string): string {
  if (SEGMENT_LABELS[seg]) return SEGMENT_LABELS[seg];
  // UUIDs and other dynamic segments: shorten to first 8 chars.
  if (/^[0-9a-f]{8,}/i.test(seg)) return seg.slice(0, 8);
  return seg.replace(/-/g, ' ');
}

/**
 * Breadcrumb — auto-derived from pathname. Per Pass 3A, only renders when
 * the path is at least two levels deep under /data (e.g., /data/admin/throughput).
 * Shallow pages (/data, /data/trajectories) skip the breadcrumb to keep the
 * top of the page calm.
 */
export function Breadcrumb() {
  const { pathname } = useLocation();
  const segments = pathname.split('/').filter(Boolean);

  // Require at least 3 segments to render: ['data', section, ...]
  if (segments.length < 3) return null;

  const crumbs: DexBreadcrumbCrumb[] = [];
  let acc = '';
  segments.forEach((seg, i) => {
    acc += `/${seg}`;
    crumbs.push({
      label: humanise(seg),
      href: i === segments.length - 1 ? undefined : acc,
    });
  });

  return (
    <div className="px-6 pt-3">
      <DexBreadcrumb items={crumbs} />
    </div>
  );
}
